class GlobalPreloaderHelper {
  preloader: HTMLElement = null;

  init() {
    this.preloader = document.getElementById('global_preloader');
  }

  show() {
    this.preloader.classList.add('visible');
  }

  hide() {
    this.preloader.classList.remove('visible');
  }
}

export default new GlobalPreloaderHelper();
